import React from 'react'

const Dashboard: React.FC = ({ children }) => (
    <main className='Dashboard'>
        { children }
    </main>
)

export default Dashboard
